import { render, staticRenderFns } from "./AboutPageWhoWeAreContent.vue?vue&type=template&id=3204705e&scoped=true"
import script from "./AboutPageWhoWeAreContent.vue?vue&type=script&lang=js"
export * from "./AboutPageWhoWeAreContent.vue?vue&type=script&lang=js"
import style0 from "./AboutPageWhoWeAreContent.vue?vue&type=style&index=0&id=3204705e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3204705e",
  null
  
)

export default component.exports